import React, { useEffect, useCallback, useState } from 'react';
import './index.scss';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';

// 只保留必要的小图片静态导入
import arrowSvg from 'asset/img/arrow.svg';
import lockedSvg from 'asset/img/locked.svg';
import title1 from 'asset/img/title1.png';
import title2 from 'asset/img/title2.png';
import title3 from 'asset/img/title3.webp';

// 静态数据
const NAME_LIST = [
  { name: '凌霄宝殿' },
  { name: '广寒宫' },
  { name: '蟠桃园' },
  { name: '兜率宫' },
  { name: '水晶宫' },
  { name: '珍珠宝殿' },
  { name: '龙吟殿' },
  { name: '珊瑚迷宫' },
  { name: '水帘洞' },
  { name: '灵猴峰' },
  { name: '云雾瀑布' },
  { name: '蝴蝶谷' },
];

const TITLES = [title1, title2, title3];
const LEVEL_ARRAY = [0, 1, 2, 3];

// 只加载原图，锁住时在 DOM 上叠加 🔒，减少图片数量和内存
const IMAGE_LOADERS = {
  'menu0-1.webp': () => import('asset/img/menu0-1.webp'),
  'menu0-2.webp': () => import('asset/img/menu0-2.webp'),
  'menu0-3.webp': () => import('asset/img/menu0-3.webp'),
  'menu0-4.webp': () => import('asset/img/menu0-4.webp'),
  'menu2-1.webp': () => import('asset/img/menu2-1.webp'),
  'menu2-2.webp': () => import('asset/img/menu2-2.webp'),
  'menu2-3.webp': () => import('asset/img/menu2-3.webp'),
  'menu2-4.webp': () => import('asset/img/menu2-4.webp'),
  'menu3-1.webp': () => import('asset/img/menu3-1.webp'),
  'menu3-2.webp': () => import('asset/img/menu3-2.webp'),
  'menu3-3.webp': () => import('asset/img/menu3-3.webp'),
  'menu3-4.webp': () => import('asset/img/menu3-4.webp'),
  'background1.webp': () => import('asset/img/background1.webp'),
  'background2.webp': () => import('asset/img/background2.webp'),
  'background3.webp': () => import('asset/img/background3.webp'),
};

const IMAGE_NAMES = [
  ['menu0-1.webp', 'menu0-2.webp', 'menu0-3.webp', 'menu0-4.webp'],
  ['menu2-1.webp', 'menu2-2.webp', 'menu2-3.webp', 'menu2-4.webp'],
  ['menu3-1.webp', 'menu3-2.webp', 'menu3-3.webp', 'menu3-4.webp'],
];
const BACKGROUND_NAMES = ['background1.webp', 'background2.webp', 'background3.webp'];

const Slide = (props) => {
  const { type, list, index, onImagesLoaded } = props;
  const navigate = useNavigate();
  
  // 只加载当前 type 需要的图片
  const [images, setImages] = useState({});
  const [background, setBackground] = useState(null);
  
  // 动态加载当前 type 的图片
  useEffect(() => {
    let isMounted = true;
    
    const loadImages = async () => {
      try {
        // 加载背景
        const bgLoader = IMAGE_LOADERS[BACKGROUND_NAMES[type]];
        const bgModule = bgLoader ? await bgLoader() : null;
        
        // 只加载原图（4 张），锁住时用 DOM 叠加 🔒
        const menuImages = {};
        for (let idx = 0; idx < 4; idx++) {
          const fileName = IMAGE_NAMES[type][idx];
          const loader = IMAGE_LOADERS[fileName];
          if (loader) {
            const module = await loader();
            menuImages[idx] = module.default;
          }
        }
        
        if (isMounted) {
          setBackground(bgModule?.default || null);
          setImages(menuImages);
          if (onImagesLoaded) {
            onImagesLoaded();
          }
        }
      } catch (err) {
        console.error('加载图片失败:', err);
      }
    };
    
    if (list?.length >= 4) {
      loadImages();
    }
    
    return () => {
      isMounted = false;
    };
  }, [type, list, onImagesLoaded]);

  const gotoDetail = useCallback((type, _index, status) => {
    if (!status) {
      return message.info(`请先通关 《${NAME_LIST[index]?.name}》`);
    }
    navigate(`/menu?type=${type}&index=${_index}`);
  }, [index, navigate]);

  return (
    <div className='menu-container'>
      {background && <img src={background} className='background' loading="lazy" decoding="async" />}
      <div className='menu-content'>
        <div className='title'><img src={TITLES[type]} /></div>
        {LEVEL_ARRAY.map((idx) => {
          const isLocked = !list[idx]?.status;
          return <div
            className={idx === 0 && type === 0 ? 'enter-8' : `enter-${idx}`}
            onClick={() => gotoDetail(type, idx, list[idx]?.status)}
            key={idx}
          >
            {list[idx]?.arrow ? <div className="guide-arrow">
              <img src={arrowSvg} alt="指引箭头" />
            </div> : null}
            {images[idx] && (
              <div className="item-wrap">
                <img
                  src={images[idx]}
                  className='item'
                  loading="lazy"
                  decoding="async"
                  alt=""
                />
                {isLocked && <img src={lockedSvg} className="lock-icon" alt="" aria-hidden />}
              </div>
            )}
          </div>
        })}
      </div>
    </div>
  );
};

export default Slide;
